import {
  createAsyncAction,
  createAsyncTypes,
} from 'lib/reduxUtils';

// Async
export const SUBMIT_FILE_DOWNLOAD_CHOICE = createAsyncTypes('fileDownload/submitFileDownloadChoice');
export const submitFileDownloadChoice = createAsyncAction(SUBMIT_FILE_DOWNLOAD_CHOICE);
